<script>
import SessionService from '@/services/api/session/session-service';
import VideoPlayer from '@/components/shared/VideoPlayer.vue';

export default {
  name: 'AICCVideoPlayer',
  extends: VideoPlayer,
  methods: {
    init() {
      this.loading = true;
      this.getVideoSource()
        .then(() => {
          this.getProgress()
            .then(() => {
              this.setup();
            });
        });
    },
    getProgress() {
      return SessionService.getProgress('AICC').then(res => {
        if (res.Core_Lesson) {
          this.currentPart = {
            status: res.Core_Lesson.s,
            score: this.convertDataType(res.Core_Lesson.qs),
            videoPosition: parseInt(res.Core_Lesson.vp),
            maxVideoPosition: parseInt(res.Core_Lesson.mp),
            watchedUntilEnd: this.convertDataType(res.Core_Lesson.we),
            endOfVideo: this.convertDataType(res.Core_Lesson.ev),
          };
          this.currentTime = parseInt(res.Core_Lesson.vp);
        }
        this.timeInCourse = this.convertTime(res.Time);
      });
    },
    saveProgress() {
      const body = {
        ...this.currentPart,
        code: this.syncguid,
        time: this.timeInCourse,
      };
      return SessionService.saveProgress(body, 'AICC');
    },
    exitSession() {
      return SessionService.exitSession('AICC').then(() => window.close());
    },
  },
};
</script>
